import React from 'react';
import PropTypes from 'prop-types';
import TermStatus from '../../../constants/termStatus';
import { Label } from '@cimpress/react-components';

function TermStatusLabel({ status }) {
  const statusToDisplayObj = {
    [TermStatus.DRAFT]: 'default',
    [TermStatus.PENDING]: 'info',
    [TermStatus.REJECTED]: 'danger',
    [TermStatus.APPROVED]: 'success',
    [TermStatus.TERMINATED]: 'danger'
  };

  return <Label text={status} type={statusToDisplayObj[status] || 'default'} />;
}

TermStatusLabel.propTypes = {
  status: PropTypes.string.isRequired
};

export default TermStatusLabel;
